import { render } from "./pb-pagehomepropertiesrent.vue?vue&type=template&id=6e08b194"
import script from "./pb-pagehomepropertiesrent.vue?vue&type=script&lang=js"
export * from "./pb-pagehomepropertiesrent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__